import React from "react";

const isChunkError = (e) => /ChunkLoadError|Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module/i.test(String(e?.name || "") + String(e?.message || ""));

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) {
    if (isChunkError(error) && !sessionStorage.getItem("pp-chunk-reloaded")) {
      sessionStorage.setItem("pp-chunk-reloaded", "1");
      window.location.reload();
    }
  }
  reset = () => {
    try { Object.keys(localStorage).filter((k) => k.startsWith("pp-")).forEach((k) => localStorage.removeItem(k)); } catch { /* ignore */ }
    sessionStorage.removeItem("pp-chunk-reloaded");
    window.location.href = "/";
  };
  render() {
    if (!this.state.error) return this.props.children;
    const chunk = isChunkError(this.state.error);
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="app-error-screen">
        <div className="max-w-md w-full rounded-lg border border-slate-200 bg-white p-6 shadow-sm space-y-3">
          <div className="text-xs font-bold tracking-widest text-blue-700 uppercase">PlantPulse</div>
          <h1 className="text-lg font-bold">{chunk ? "A new version was deployed" : "Something went wrong on this screen"}</h1>
          <p className="text-sm text-slate-600">{chunk ? "Your browser is holding an older copy of the app. Reload to get the latest version." : "The page hit an unexpected error. Reloading usually fixes it; if it keeps happening, use “Reset & sign in again” and tell your admin what you were doing."}</p>
          <pre className="text-[11px] text-rose-700 bg-rose-50 border border-rose-100 rounded p-2 overflow-auto max-h-24">{String(this.state.error?.message || this.state.error)}</pre>
          <div className="flex gap-2">
            <button type="button" className="pp-btn-primary h-9 px-4" onClick={() => window.location.reload()} data-testid="app-error-reload">Reload</button>
            <button type="button" className="pp-btn-ghost h-9 px-4" onClick={this.reset} data-testid="app-error-reset">Reset & sign in again</button>
          </div>
        </div>
      </div>
    );
  }
}
